var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-5" }, [
          _c("div", { staticClass: "form-group row pb-4" }, [
            _c("label", {
              staticClass: "col-lg-3 text-lg-end pt-2",
              attrs: { for: "input-alamat-email" },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-8" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "col-lg-4",
                    attrs: { variant: "success" },
                    on: { click: _vm.toggleKeyboard },
                  },
                  [_vm._v("Keyboard")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("Tiket", {
        attrs: {
          show: _vm.showTiketModal,
          datum: _vm.tiketObj,
          "on-close": function () {
            _vm.showTiketModal = false
            _vm.tiketObj = {}
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-tabs",
        { attrs: { "content-class": "mt-3" } },
        [
          _c(
            "b-tab",
            {
              attrs: { title: "Pendaftaran Pasien", active: "" },
              on: { click: _vm.clearDataPasien },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-5" }, [
                  _c("div", { staticClass: "form-group row pb-4" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-lg-3 text-lg-end pt-2",
                        attrs: { for: "input-no-rm" },
                      },
                      [_vm._v("NIK")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-8" },
                      [
                        _c(
                          "b-input-group",
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.nik,
                                  expression: "form.nik",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "input-no-rm",
                                autocomplete: "off",
                              },
                              domProps: { value: _vm.form.nik },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.searchPasien.apply(null, arguments)
                                },
                                focus: _vm.setInputKeyboard,
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(_vm.form, "nik", $event.target.value)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "b-input-group-append",
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "success" },
                                    on: { click: _vm.searchPasien },
                                  },
                                  [_c("i", { staticClass: "fa fa-search" })]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.validation.nik
                          ? _c(
                              "small",
                              {
                                staticClass: "form-text text-danger",
                                attrs: {
                                  tabindex: "-1",
                                  id: "input-group-1__BV_description_",
                                },
                              },
                              [_vm._v("NIK harus diisi!")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.data_pasien
                ? _c("FormPasien", {
                    attrs: {
                      data_pasien: _vm.data_pasien,
                      no_rujukan: _vm.no_rujukan,
                      "on-register-success": _vm.registerSuccess,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-tab", { attrs: { title: "List Pendaftaran Online" } }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-5" }, [
                _c("div", { staticClass: "form-group row pb-4" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-lg-3 text-lg-end pt-2",
                      attrs: { for: "input-tanggal-registrasi" },
                    },
                    [_vm._v("Tanggal")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-8" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.tanggal_registrasi,
                          expression: "tanggal_registrasi",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "date", id: "input-tanggal-registrasi" },
                      domProps: { value: _vm.tanggal_registrasi },
                      on: {
                        change: _vm.getRegisters,
                        focus: _vm.setInputKeyboard,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.tanggal_registrasi = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-5" }, [
                _c("div", { staticClass: "form-group row pb-4" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-lg-3 text-lg-end pt-2",
                      attrs: { for: "input-nik-registrasi" },
                    },
                    [_vm._v("NIK")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-8" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nik_registrasi,
                          expression: "nik_registrasi",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number", id: "input-nik-registrasi" },
                      domProps: { value: _vm.nik_registrasi },
                      on: {
                        change: _vm.getRegisters,
                        focus: _vm.setInputKeyboard,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.nik_registrasi = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { attrs: { id: "tabledata-regsters" } }),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.data_keyboard.visible
        ? _c("vue-touch-keyboard", {
            attrs: {
              options: _vm.data_keyboard.options,
              layout: _vm.data_keyboard.layout,
              cancel: _vm.data_keyboard.hide,
              accept: _vm.data_keyboard.accept,
              input: _vm.data_keyboard.input,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }